import calendarPprGrid from "../../view/ppr/calendar/calendarPprGrid";

export default {
  ppr_calendar: calendarPprGrid,
};
